import isEqual from 'deep-equal';

import Server from '../../lib/modules/server.js';
import AppNexus from './appNexus.js';

export default function loadAppNexus() {
    if (window.location.host.indexOf('localhost') < 0) {
        const appNexusScript = document.createElement('script');
        appNexusScript.src = 'https://acdn.adnxs.com/ast/static/0.16.1/ast.js';
        appNexusScript.type = 'text/javascript';
        appNexusScript.defer = true;
        appNexusScript.async = true;
        document.body.appendChild(appNexusScript);

        const cogwheelScript = document.createElement('script');
        cogwheelScript.type = 'text/javascript';
        cogwheelScript.defer = true;
        cogwheelScript.src = 'https://sdk.pulse.schibsted.com/gdpr-transparency-apnxs/latest/gdpr-bundle.js';
        document.body.appendChild(cogwheelScript);
    }

    window.apntag = window.apntag || {};

    return new AppNexus({
        server: new Server(FINN.travel.banner.url),
        apntag: window.apntag,
        _window: window,
        isEqual,
    });
}
